<template>
	<section class="Clients">
		<div class="container">
			<h2 class="title-box">{{$t("clientes.titulo")}}</h2>

			<article>
				<ul>
					<li v-for=" client in clients">
						<a href="javascript:;"> <img class="responsiva" :src="client.image" :alt="client.name"></a>
					</li>
				</ul>
			</article>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["clients", "titulo"]
    }

</script>

<style lang="scss">
	.Clients {
		background-color: #eee;
		padding: 60px 0;
		text-align: center;

		.container {
			ul {
				flex-basis: 100%;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: center;

				li {
					flex-basis: calc(100% / 5);
					list-style: none;
					justify-content: center;
					align-items: center;
					margin: 15px 0;
				}
			}
		}

	}

	@media( max-width: 1024px) {
		.Clients {
			.container {
				ul {
					width: 90%;
					margin: 0 auto;

					li {
						flex-basis: calc(100% / 4);
					}
				}
			}
		}
	}
	@media( max-width: 768px) {
		.Clients {
			.container {
				ul {
					width: 90%;
					margin: 0 auto;

					li {
						flex-basis: calc(100% / 3);
					}
				}
			}
		}
	}

	@media( max-width: 640px) {
		.Clients {
			.container {
				ul {
					width: 90%;
					margin: 0 auto;

					li {
						flex-basis: calc(100% / 2);
					}
				}
			}
		}
	}

	@media( max-width: 480px) {
		.Clients {
			.container {
				ul {
					li {
						flex-basis: calc(100% / 2);
					}
				}
			}
		}
	}

	@media( max-width: 360px) {
		.Clients {
			.container {
				ul {
					li {
						flex-basis: 100%;
						margin-bottom: 20px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/Clients.vue